import ApiService from "./api.service";
export default class ProductService extends ApiService {
    static base_url = `${super.base_url}/products`;
}
